/**
 * This file is used for dependency injections
 */
import { Services as ServiceType, ServiceName, ServiceCast } from '../types/Services';
import { GlobalErrorService } from './GlobalError';
import { api } from './api';
import StartService from './Start';
import { LoginService } from './Login';
import { BrowsingService } from './Browsing';
import { MediaService } from './Media';
import { PopupsService } from './Popups';
import { ProductService } from './Product';

class ServicesClass implements ServiceType {
  private services: { [key in ServiceName]: () => ServiceCast };

  private instances: { [key in ServiceName]?: ServiceCast } = {};

  public constructor() {
    this.services = {
      [ServiceName.Api]: () => api,
      [ServiceName.Browsing]: () => new BrowsingService(),
      [ServiceName.GlobalError]: () => new GlobalErrorService(),

      [ServiceName.Login]: () => new LoginService(this.selfReference()),
      [ServiceName.Start]: () => new StartService(this.selfReference()),
      [ServiceName.MediaService]: () => new MediaService(this.selfReference()),
      [ServiceName.Popups]: () => new PopupsService(this.selfReference()),
      [ServiceName.Product]: () => new ProductService(this.selfReference()),
    };
  }

  public get<T extends ServiceCast>(name: ServiceName): T {
    if (this.instances[name]) {
      return this.instances[name] as T;
    }
    return this.instances[name] = this.services[name]() as T;
  }

  private selfReference(): Promise<ServiceType> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return new Promise((resolve) => setTimeout(() => {
      resolve(self);
    }, 0));
  }
}

const Services = new ServicesClass();

export { Services };
